import { useAlgoliaSortBy } from "@/hooks/useAlgoliaSortBy";
import * as RadioGroup from "@radix-ui/react-radio-group";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";
import { cn } from "@repo/ui/lib/utils";

export default function AlgoliaSortBy({ title }: { title: string }) {
  const { refine, options, currentRefinement } = useAlgoliaSortBy();

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="item-1">
        <div className="py-[16px]">
          <AccordionTrigger className="max-md:text-base font-medium py-0 data-[state=open]:text-primary-magenta">
            {title}
          </AccordionTrigger>
          <AccordionContent className="mt-[20px] pb-0">
            <RadioGroup.Root
              className="flex flex-col"
              value={currentRefinement}
              onValueChange={(value) => refine(value)}
            >
              {options.map((item) => (
                <div className="flex items-center gap-4 py-2" key={item.value}>
                  <label
                    className={cn("cursor-pointer flex-grow", {
                      "font-bold": item.value === currentRefinement,
                    })}
                    htmlFor={item.value}
                  >
                    {item.label}
                  </label>
                  <RadioGroup.Item
                    className="w-3 h-3 bg-transparent rounded-full"
                    value={item.value}
                    id={item.value}
                  >
                    <RadioGroup.Indicator className="flex w-full h-full justify-center items-center relative :after:content-[''] after:bg-primary-magenta after:w-3 after:h-3 after:rounded-full" />
                  </RadioGroup.Item>
                </div>
              ))}
            </RadioGroup.Root>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
